import * as React from "react"

function SvgOval(props) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M19.625 10a9.625 9.625 0 11-19.25 0 9.625 9.625 0 0119.25 0z"
        stroke="currentColor"
        strokeWidth={0.75}
      />
    </svg>
  )
}

export default SvgOval
